import React from "react";
import "../App.css";
import { Link, useNavigate } from "react-router-dom";

export default function LandingPage() {
  const router = useNavigate();

  return (
    <div className="landingPageContainer">
      {/* NAVBAR */}
      <nav className="navbar">
        <div className="navHeader">
          <h2>🎥Zoom Video Call</h2>
        </div>

        <div className="navlist">
          <p onClick={() => router("/aljk23")}>Join as Guest</p>
          <p onClick={() => router("/auth")}>Register</p>
          <button onClick={() => router("/auth")} className="navBtn">
            Login
          </button>
        </div>
      </nav>

      {/* HERO SECTION */}
      <div className="landingMainContainer">
        <div className="heroText fadeIn">
          <h1>
            <span>Connect</span> with your <br /> loved ones
          </h1>
          <p>High quality, secure video meetings — anywhere, anytime.</p>

          <div className="ctaButtons">
            <Link to="/auth" className="primaryBtn">
              Get Started
            </Link>
            <Link to="/aljk23" className="secondaryBtn">
              Join as Guest
            </Link>
          </div>
        </div>

        <div className="heroImage fadeIn">
          <img src="/mobile.png" alt="Video Call Preview" />
        </div>
      </div>
    </div>
  );
}
